export default {
  brand: "Clefs de Lys SA",
  hero: {
    subtitle: "Schlüssel, Zylinder & Reparaturen",
    tagline: "Schlüssel, Schlosserei, Reparaturen... Seit über 25 Jahren unser Fachgebiet!",
    cta: "Kontaktieren Sie Uns",
    operatingSince: "Seit 2001 in Betrieb",
  },
  nav: {
    home: "Startseite",
    blog: "Blog",
    partners: "Partner",
    contact: "Kontakt",
  },
  services: {
    badge: "Unsere Dienstleistungen",
    heading: "Was Wir Anbieten",
    description: "Umfassende Schlosserei- und Sicherheitslösungen, zugeschnitten auf Ihre Bedürfnisse",
    items: {
      keyCutting: {
        title: "Präzisions-Schlüsselschnitt",
        description: "Hochpräzise Schlüsselduplizierung mit modernsten Maschinen für alle großen Marken und kundenspezifische Profile.",
      },
      cylinders: {
        title: "Zylindersysteme",
        description: "Hochwertige Schließzylinder und komplette Sicherheitssysteme für private, gewerbliche und industrielle Anwendungen.",
      },
      masterKey: {
        title: "Schließanlagen-Lösungen",
        description: "Maßgeschneiderte Schließanlagen-Hierarchien für Immobilienverwalter, Hotels und große Einrichtungen.",
      },
      repair: {
        title: "Reparatur & Installation",
        description: "Professionelle Schlosserreparatur, Austausch und Neuinstallationsdienste mit schnellen Reaktionszeiten.",
      },
    },
  },
  about: {
    label: "Über Clefs de Lys SA",
    text: "2001 im Herzen der Schweiz gegründet, hat sich Clefs de Lys SA von einer kleinen Schlosserwerkstatt zu einem vertrauenswürdigen Namen in der Schlüsselfertigung und bei Sicherheitszylindersystemen entwickelt. Wir kombinieren traditionelle Handwerkskunst mit moderner Präzisionstechnologie, um Tausende von Privat- und Geschäftskunden in der gesamten Region zu bedienen.",
    stats: {
      experience: "Jahre Erfahrung",
      keys: "Schlüssel pro Jahr",
      satisfaction: "Kundenzufriedenheit",
      partners: "Geschäftspartner",
    },
  },
  trust: {
    label: "In Zahlen",
    heading: "Präzision in Zahlen",
    text: "Über ein Vierteljahrhundert Schweizer Handwerkskunst, Schlüssel für Schlüssel. So sieht das in Zahlen aus.",
    counters: {
      keys: {
        value: "250K+",
        label: "Schlüssel Geschnitten",
      },
      cylinders: {
        value: "85K+",
        label: "Zylinder Installiert",
      },
      clients: {
        value: "12K+",
        label: "Zufriedene Kunden",
      },
      projects: {
        value: "3,2K+",
        label: "Sicherheitsprojekte",
      },
      response: {
        value: "<24h",
        label: "Reaktionszeit",
      },
    },
  },
  partners: {
    badge: "Vertrauenswürdiges Netzwerk",
    heading: "Unsere Lieferanten & Partner",
    description: "Wir arbeiten mit den angesehensten Herstellern und Händlern der Schweiz zusammen, um Ihnen die besten Produkte zu bieten",
    keyPartners: "Schlüssel- & Zylinder-Partner",
    allPartners: "Lieferanten",
    realEstate: "Immobilien-Partner",
    realEstateDescription: "Vertrauenswürdige Immobilienagenturen und Hausverwaltungen, mit denen wir stolz zusammenarbeiten",
    viewAll: "Alle Anzeigen",
    pageHeading: "Alle Partner & Lieferanten",
    pageDescription: "Entdecken Sie unser vollständiges Netzwerk vertrauenswürdiger Partner, Lieferanten und Mitarbeiter in der Schweiz und darüber hinaus.",
  },
  blog: {
    badge: "Neueste Artikel",
    heading: "Einblicke & Fachwissen",
    description: "Tipps, Anleitungen und Branchennachrichten von den vertrauenswürdigen Schlüssel- und Zylinderspezialisten der Schweiz.",
    readMore: "Weiterlesen",
    backToAll: "Zurück zu allen Artikeln",
    backToBlog: "Zurück zum Blog",
    notFoundTitle: "Artikel Nicht Gefunden",
    notFoundText: "Der gesuchte Artikel existiert nicht oder wurde möglicherweise verschoben.",
    relatedTitle: "Ähnliche Artikel",
    helpfulTitle: "War dieser Artikel hilfreich?",
    helpfulText: "Teilen Sie ihn mit Ihrem Team oder Ihren Kollegen.",
    shareX: "Auf X teilen",
    shareLinkedIn: "Auf LinkedIn teilen",
    copyLink: "Link kopieren",
  },
  cta: {
    heading: "Bereit, das zu sichern, was zählt?",
    description: "Ob Sie einen einzelnen Schlüssel nachmachen lassen oder ein komplettes Schließanlagensystem für Ihr Gebäude benötigen – unser Team hilft Ihnen gerne weiter.",
    button: "Kontaktieren Sie Uns",
    addressLabel: "Besuchen Sie Uns",
    phoneLabel: "Rufen Sie An",
    emailLabel: "E-Mail",
  },
  footer: {
    heading: "Bleiben Sie Informiert",
    description: "Abonnieren Sie unseren Newsletter für Sicherheitstipps und Unternehmens-Updates.",
    placeholder: "Ihre E-Mail-Adresse",
    subscribe: "Abonnieren",
    success: "Vielen Dank für Ihr Abonnement!",
    error: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
    navigation: "Navigation",
    contact: "Kontakt",
    address: "Adresse",
    addressLines: "Rue Alexandre Cailler 6, 1636 Broc, Schweiz",
    privacy: "Datenschutzerklärung",
    legal: "Impressum",
    terms: "AGB",
    rights: "Alle Rechte vorbehalten.",
  },
  contact: {
    badge: "Kontaktieren Sie Uns",
    heading: "Kontaktieren Sie Uns",
    description: "Ob Sie einen Schlüssel nachmachen lassen, einen Zylinder ersetzen oder Rat zur Sicherung Ihrer Immobilie benötigen — wir sind für Sie da.",
    formTitle: "Senden Sie uns eine Nachricht",
    name: "Name",
    namePlaceholder: "Ihr Name",
    email: "E-Mail",
    emailPlaceholder: "ihre@email.com",
    phone: "Telefon",
    phonePlaceholder: "+41 XX XXX XX XX",
    message: "Nachricht",
    messagePlaceholder: "Wie können wir Ihnen helfen?",
    photo: "Fotos (optional)",
    photoHint: "Fügen Sie Fotos Ihres Schlosses, Schlüssels oder Ihrer Tür bei — JPG, PNG, WebP und mehr akzeptiert",
    send: "Nachricht Senden",
    success: "Nachricht erfolgreich gesendet!",
    errorGeneric: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
    errorNetwork: "Netzwerkfehler. Bitte prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
    infoTitle: "Kontaktinformationen",
    addressLabel: "Adresse",
    phoneLabel: "Telefon",
    emailLabel: "E-Mail",
    hoursLabel: "Öffnungszeiten",
    getDirections: "Route Planen",
    days: {
      monday: "Montag",
      tuesday: "Dienstag",
      wednesday: "Mittwoch",
      thursday: "Donnerstag",
      friday: "Freitag",
    },
    closed: "Geschlossen",
    hoursSlot: "07:30 – 12:00 / 13:30 – 17:00",
    holidaysNote: "Für den Schlüsseldienst ist das Geschäft an Feiertagen, arbeitsfreien Tagen und Brückentagen geschlossen.",
  },
  presentation: {
    heading: "Clefs de Lys SA bietet mehrere Dienstleistungen in den folgenden Bereichen an:",
    items: [
      "Reparatur von Schlössern, Zylindern, Schlüsseln, Tresoren, etc.",
      "Türschließer-Montage, Türstopper, Einstellungen, Austausch",
      "Einbruchschutzsysteme",
      "Elektronische Schlösser, elektrische Türöffner, etc.",
      "Elektrische Zylinder",
      "Verkauf und Installation von Tresoren",
      "Erstellung von Schließplänen",
      "Schlüsseldienst",
      "Kleine Schlosserarbeiten",
    ],
  },
  language: "Sprache",
  privacyPolicy: {
    title: "Datenschutzerklärung",
    lastUpdated: "Letzte Aktualisierung: 22.07.2026",
    sections: [
      {
        heading: "1. Verantwortlicher",
        body: "Die für die Verarbeitung personenbezogener Daten gemäß der schweizerischen Datenschutzgesetzgebung verantwortliche Stelle ist:\n\nClefs de Lys SA\nRue Alexandre Cailler 6\n1636 Broc\nSchweiz\n\nE-Mail: service@clefsdelys.ch\nTelefon: +41 26 919 53 60",
      },
      {
        heading: "2. Allgemeine Informationen",
        body: "Der Schutz Ihrer personenbezogenen Daten ist Clefs de Lys SA wichtig. Wir verarbeiten personenbezogene Daten in Übereinstimmung mit dem Schweizer Bundesgesetz über den Datenschutz (DSG) und anderen anwendbaren gesetzlichen Bestimmungen.\n\nDiese Datenschutzerklärung erläutert, welche personenbezogenen Daten wir erheben, wie wir sie verwenden und welche Rechte Sie in Bezug auf Ihre persönlichen Daten haben.",
      },
      {
        heading: "3. Erhobene Personenbezogene Daten",
        body: "Im Rahmen unserer Geschäftstätigkeit können wir folgende personenbezogenen Daten erheben und verarbeiten:\n\n• Vor- und Nachname;\n• Postanschrift;\n• E-Mail-Adresse;\n• Telefonnummer;\n• Informationen zu Anfragen, Angeboten und Bestellungen;\n• Informationen zu unseren Dienstleistungen (Schlüssel, Zylinder, Schließsysteme, Schließanlagen, Schließpläne und Schlosserarbeiten);\n• Informationen, die für Rechnungsstellung und administrative Zwecke erforderlich sind.",
      },
      {
        heading: "4. Zweck der Datenverarbeitung",
        body: "Clefs de Lys SA verarbeitet personenbezogene Daten ausschließlich zu legitimen Geschäftszwecken, einschließlich:\n\n• Bearbeitung von Kundenanfragen und -bestellungen;\n• Erstellung von Angeboten und Offerten;\n• Erbringung von Schlosser- und Sicherheitsdienstleistungen;\n• Pflege der Kundenbeziehungen;\n• Rechnungsstellung und Erfüllung buchhalterischer Pflichten;\n• Kommunikation mit Kunden bezüglich unserer Dienstleistungen.",
      },
      {
        heading: "5. Rechtsgrundlage der Verarbeitung",
        body: "Die Verarbeitung personenbezogener Daten beruht auf:\n\n• Der Erfüllung vertraglicher Pflichten oder vorvertraglicher Maßnahmen;\n• Der Einhaltung gesetzlicher Verpflichtungen;\n• Unserem berechtigten Interesse an der Bereitstellung sicherer und zuverlässiger Dienstleistungen.",
      },
      {
        heading: "6. Weitergabe von Personenbezogenen Daten an Dritte",
        body: "Clefs de Lys SA verkauft, vermietet oder handelt nicht mit personenbezogenen Daten.\n\nPersonenbezogene Daten dürfen nur dann an Dritte weitergegeben werden, wenn dies erforderlich ist, insbesondere an:\n\n• Lieferanten oder Partner, die an der Ausführung von Kundenaufträgen beteiligt sind;\n• Technische Dienstleister, die für unsere IT-Systeme und den Website-Betrieb erforderlich sind;\n• Öffentliche Behörden, wenn dies gesetzlich vorgeschrieben ist.\n\nAlle beteiligten Dritten sind verpflichtet, die Vertraulichkeit und Sicherheit der personenbezogenen Daten zu wahren.",
      },
      {
        heading: "7. Vertraulichkeit von Sicherheitsinformationen",
        body: "Aufgrund der Art unserer Tätigkeit kann Clefs de Lys SA vertrauliche sicherheitsrelevante Informationen verarbeiten, einschließlich:\n\n• Informationen zu Schließanlagen;\n• Schließpläne;\n• Zylinderkonfigurationen;\n• Zugangskontrollinformationen.\n\nDiese Informationen werden vertraulich behandelt und ausschließlich für autorisierte Zwecke und legitime Kunden verarbeitet.",
      },
      {
        heading: "8. Datenspeicherung",
        body: "Clefs de Lys SA bewahrt personenbezogene Daten nur so lange auf, wie es zur Erfüllung der Zwecke, für die sie erhoben wurden, erforderlich ist.\n\nGeschäfts- und buchhaltungsrelevante Informationen werden gemäß den in der Schweiz geltenden gesetzlichen Aufbewahrungsfristen aufbewahrt.",
      },
      {
        heading: "9. Datensicherheit",
        body: "Wir treffen angemessene technische und organisatorische Maßnahmen, um personenbezogene Daten zu schützen vor:\n\n• Unbefugtem Zugriff;\n• Verlust oder Zerstörung;\n• Unbefugter Veränderung;\n• Offenlegung gegenüber unbefugten Personen.",
      },
      {
        heading: "10. Cookies und Website-Technologien",
        body: "Unsere Website kann Cookies und ähnliche Technologien verwenden, um die ordnungsgemäße Funktionalität der Website zu gewährleisten und die Benutzererfahrung zu verbessern.\n\nCookies können verwendet werden für:\n\n• Den technischen Betrieb der Website;\n• Das Speichern von Benutzereinstellungen;\n• Die Analyse der Website-Performance (nur wenn Analysetools implementiert sind).\n\nSie können Cookies über Ihre Browsereinstellungen verwalten oder deaktivieren.",
      },
      {
        heading: "11. Externe Links",
        body: "Unsere Website kann Links zu externen Websites enthalten.\n\nClefs de Lys SA ist nicht verantwortlich für die Datenschutzpraktiken oder den Inhalt von Websites Dritter. Wir empfehlen, die Datenschutzerklärungen dieser Websites gesondert zu prüfen.",
      },
      {
        heading: "12. Ihre Rechte",
        body: "Nach geltendem Datenschutzrecht haben Sie möglicherweise das Recht auf:\n\n• Auskunft über Ihre personenbezogenen Daten;\n• Berichtigung unrichtiger Daten;\n• Löschung Ihrer personenbezogenen Daten, soweit gesetzlich zulässig;\n• Widerspruch gegen bestimmte Verarbeitungstätigkeiten.\n\nZur Ausübung Ihrer Rechte kontaktieren Sie uns bitte über die oben angegebenen Kontaktdaten.",
      },
      {
        heading: "13. Änderungen dieser Datenschutzerklärung",
        body: "Clefs de Lys SA behält sich das Recht vor, diese Datenschutzerklärung bei Bedarf aufgrund rechtlicher, technischer oder organisatorischer Änderungen zu aktualisieren.\n\nEs gilt die jeweils aktuelle, auf unserer Website veröffentlichte Version.",
      },
    ],
  },
  legalNotice: {
    title: "Impressum",
    lastUpdated: "Letzte Aktualisierung: 22.07.2026",
    sections: [
      {
        heading: "Unternehmensinformationen",
        body: "Clefs de Lys SA\nRue Alexandre-Cailler 6\n1636 Broc\nSchweiz\n\nRechtsform: Société Anonyme (SA)\n\nUID / CHE-Nummer: CHE-109.270.807\n\nHandelsregisternummer: CH-217.0.431.678-4\n\nHandelsregisteramt: Kanton Freiburg, Schweiz",
      },
      {
        heading: "Kontaktinformationen",
        body: "Telefon: +41 26 919 53 60\nE-Mail: service@clefsdelys.ch\nWebsite: www.Clefsdelys.ch",
      },
      {
        heading: "Verantwortlich für den Website-Inhalt",
        body: "Das für den Inhalt dieser Website verantwortliche Unternehmen ist:\n\nClefs de Lys SA\nRue Alexandre-Cailler 6\n1636 Broc\nSchweiz",
      },
      {
        heading: "Zweck der Website",
        body: "Diese Website informiert über Clefs de Lys SA und deren Dienstleistungen, einschließlich Schlosserdienstleistungen, Schlüsseldienst, Zylinder, Schließsysteme, Schließanlagen, Sicherheitslösungen und damit verbundene professionelle Dienstleistungen.",
      },
      {
        heading: "Geistiges Eigentum",
        body: "Alle auf dieser Website veröffentlichten Inhalte, einschließlich Texte, Bilder, Logos, Grafiken, Dokumente und sonstiger Materialien, sind durch die geltenden Gesetze zum geistigen Eigentum geschützt.\n\nJegliche Vervielfältigung, Verbreitung, Änderung oder Nutzung der Website-Inhalte ohne vorherige schriftliche Genehmigung von Clefs de Lys SA ist untersagt.",
      },
      {
        heading: "Haftungsausschluss",
        body: "Clefs de Lys SA bemüht sich sicherzustellen, dass die auf dieser Website bereitgestellten Informationen korrekt, vollständig und aktuell sind.\n\nClefs de Lys SA kann jedoch nicht garantieren, dass die auf dieser Website veröffentlichten Informationen stets frei von Fehlern oder Auslassungen sind.\n\nClefs de Lys SA übernimmt keine Haftung für direkte oder indirekte Schäden, die aus der Nutzung dieser Website oder der darin enthaltenen Informationen entstehen.",
      },
      {
        heading: "Externe Links",
        body: "Diese Website kann Links zu externen Websites enthalten, die von Dritten betrieben werden.\n\nClefs de Lys SA hat keine Kontrolle über den Inhalt, die Verfügbarkeit oder die Datenschutzpraktiken dieser externen Websites und übernimmt keine Verantwortung für diese.",
      },
      {
        heading: "Datenschutz",
        body: "Die Verarbeitung der über diese Website erhobenen personenbezogenen Daten richtet sich nach unserer Datenschutzerklärung.\n\nWeitere Informationen zur Erhebung, Nutzung und zum Schutz personenbezogener Daten finden Sie in unserer Datenschutzerklärung.",
      },
      {
        heading: "Anwendbares Recht und Gerichtsstand",
        body: "Dieses Impressum unterliegt schweizerischem Recht.\n\nStreitigkeiten aus der Nutzung dieser Website unterliegen den zuständigen Gerichten in der Schweiz, sofern nicht zwingende gesetzliche Bestimmungen etwas anderes vorsehen.",
      },
    ],
  },
  termsOfService: {
    title: "Allgemeine Geschäftsbedingungen",
    lastUpdated: "Inkrafttreten: 22. Juli 2026",
    intro: "Willkommen auf der Website von Clefs de Lys SA. Diese Allgemeinen Geschäftsbedingungen (die «AGB») regeln Ihren Zugang zu und Ihre Nutzung unserer Website, Produkte und Dienstleistungen. Durch den Zugriff auf diese Website oder die Inanspruchnahme unserer Dienstleistungen erklären Sie sich mit diesen AGB einverstanden. Wenn Sie nicht einverstanden sind, stellen Sie bitte die Nutzung der Website ein.",
    sections: [
      {
        heading: "1. Über Clefs de Lys SA",
        body: "Clefs de Lys SA ist ein Schweizer Schlosser- und Sicherheitsunternehmen, das professionelle Lösungen für Privat-, Gewerbe- und Industriekunden anbietet. Zu unseren Dienstleistungen gehören die Schlüsselduplizierung, Sicherheitszylinder, Schließanlagen, Zutrittskontrolllösungen, Türbeschläge, Tresorinstallationen, Schlosserreparaturen, Schlüsseldienst-Notdienste und damit verbundene Sicherheitsdienstleistungen.",
      },
      {
        heading: "2. Annahme dieser AGB",
        body: "Durch die Nutzung dieser Website, die Anforderung eines Angebots, die Erteilung einer Bestellung oder die Inanspruchnahme unserer Dienstleistungen bestätigen Sie, dass Sie diese Allgemeinen Geschäftsbedingungen gelesen, verstanden und akzeptiert haben.",
      },
      {
        heading: "3. Nutzung der Website",
        body: "Sie verpflichten sich, diese Website verantwortungsvoll und nur für rechtmäßige Zwecke zu nutzen.\n\nEs ist Ihnen untersagt:\n\n• den Betrieb oder die Sicherheit der Website zu beeinträchtigen;\n• unbefugten Zugriff auf unsere Systeme zu versuchen;\n• schädliche Software oder schädliche Inhalte hochzuladen;\n• Kontaktformulare oder Kommunikationskanäle zu missbrauchen;\n• Website-Inhalte ohne vorherige schriftliche Genehmigung zu vervielfältigen oder zu verbreiten.",
      },
      {
        heading: "4. Informationen auf der Website",
        body: "Wir bemühen uns nach besten Kräften sicherzustellen, dass alle auf dieser Website veröffentlichten Informationen korrekt und aktuell sind.\n\nProduktbeschreibungen, Spezifikationen, Verfügbarkeit, Bilder und Preise dienen jedoch nur der allgemeinen Information und können ohne vorherige Ankündigung aktualisiert oder korrigiert werden.",
      },
      {
        heading: "5. Produkte und Dienstleistungen",
        body: "Unsere Produkte und Dienstleistungen können umfassen:\n\n• Schlüsselschnitt und -duplizierung\n• Sicherheitszylinder\n• Mechanische und elektronische Schließsysteme\n• Schließanlagen\n• Zutrittskontrolllösungen\n• Tresore und sichere Aufbewahrungsprodukte\n• Türbeschläge\n• Schlossinstallation und -reparaturen\n• Schlüsseldienst-Notdienste\n• Wartung und Sicherheits-Upgrades\n\nDie Verfügbarkeit kann je nach Lagerbestand, Lieferanten oder technischen Anforderungen variieren.",
      },
      {
        heading: "6. Angebote und Bestellungen",
        body: "Alle Angebote sind freibleibend, sofern nicht ausdrücklich anders angegeben.\n\nEine Bestellung wird erst nach Bestätigung durch Clefs de Lys SA verbindlich.\n\nBei bestimmten Sicherheitsprodukten können Kunden verpflichtet sein, vor der Herstellung oder Lieferung einen Eigentumsnachweis, eine Identitätsprüfung, Berechtigungskarten oder zusätzliche Unterlagen vorzulegen.\n\nWir behalten uns das Recht vor, Bestellungen abzulehnen oder zu stornieren, die nicht verifiziert werden können oder nicht den gesetzlichen oder sicherheitstechnischen Anforderungen entsprechen.",
      },
      {
        heading: "7. Preise und Zahlung",
        body: "Preise können sich bis zur Bestätigung einer Bestellung ohne vorherige Ankündigung ändern.\n\nRechnungen sind innerhalb der auf der Rechnung angegebenen Zahlungsfrist zu begleichen.\n\nZahlungsverzug kann Mahngebühren, gesetzliche Verzugszinsen, die Aussetzung von Dienstleistungen oder gerichtliche Beitreibungsverfahren nach sich ziehen, soweit dies nach schweizerischem Recht zulässig ist.",
      },
      {
        heading: "8. Lieferung und Installation",
        body: "Liefertermine sind Schätzungen, sofern nicht ausdrücklich schriftlich bestätigt.\n\nClefs de Lys SA übernimmt keine Verantwortung für Verzögerungen, die durch Lieferanten, Hersteller, Transportunternehmen, Zollverfahren, Ereignisse höherer Gewalt oder Umstände außerhalb unserer angemessenen Kontrolle verursacht werden.\n\nKunden sind dafür verantwortlich, einen sicheren Zugang zu den Installationsorten zu gewährleisten.\n\nZusätzliche Arbeiten, die während der Installation angefordert werden, können nach Genehmigung durch den Kunden zu zusätzlichen Kosten führen.",
      },
      {
        heading: "9. Notdienste",
        body: "Schlüsseldienst-Notdienste werden je nach Verfügbarkeit der Techniker angeboten.\n\nReaktionszeiten können nicht garantiert werden und hängen von der Arbeitsbelastung, der Entfernung, den Wetterbedingungen, dem Verkehr und den betrieblichen Umständen ab.\n\nAußerhalb der normalen Geschäftszeiten können zusätzliche Gebühren anfallen.",
      },
      {
        heading: "10. Kundenpflichten",
        body: "Kunden sind dafür verantwortlich, bei der Anforderung von Produkten oder Dienstleistungen genaue und vollständige Informationen bereitzustellen.\n\nDies umfasst, soweit zutreffend:\n\n• Schlossreferenzen;\n• Zylinderabmessungen;\n• Schlüsselnummern;\n• Sicherheitsberechtigungsdokumente;\n• Installationsdetails;\n• Eigentumsinformationen.\n\nUnrichtige Angaben können zu Verzögerungen, zusätzlichen Kosten oder inkompatiblen Produkten führen.",
      },
      {
        heading: "11. Gewährleistung",
        body: "Soweit zutreffend, unterliegen Produkte der Herstellergarantie.\n\nVon Clefs de Lys SA durchgeführte Installations- und Reparaturarbeiten sind gemäß dem anwendbaren schweizerischen Recht oder einer etwaigen schriftlich erteilten Garantie gegen Verarbeitungsmängel abgedeckt.\n\nDie Gewährleistung erstreckt sich nicht auf Schäden, die durch unsachgemäße Verwendung, unbefugte Änderungen, Unfälle, normale Abnutzung, unsachgemäße Wartung oder Eingriffe Dritter entstehen.",
      },
      {
        heading: "12. Haftungsbeschränkung",
        body: "Soweit gesetzlich zulässig, haftet Clefs de Lys SA nicht für indirekte, zufällige, Folge- oder wirtschaftliche Schäden, die aus der Nutzung dieser Website, der Produkte oder Dienstleistungen entstehen.\n\nNichts in diesen AGB schränkt die Haftung ein, soweit eine solche Einschränkung durch zwingendes schweizerisches Recht untersagt ist.",
      },
      {
        heading: "13. Geistiges Eigentum",
        body: "Alle auf dieser Website verfügbaren Inhalte — einschließlich Texte, Grafiken, Logos, Symbole, Bilder, Dokumente, Layouts und Software — sind Eigentum von Clefs de Lys SA oder ihrer Lizenzgeber und durch die Gesetze zum geistigen Eigentum geschützt.\n\nKein Inhalt darf ohne vorherige schriftliche Genehmigung kopiert, vervielfältigt, verbreitet oder verändert werden.",
      },
      {
        heading: "14. Datenschutz",
        body: "Ihre Nutzung dieser Website unterliegt ebenfalls unserer Datenschutzerklärung.\n\nPersonenbezogene Daten werden nur zu legitimen Geschäftszwecken und in Übereinstimmung mit der anwendbaren schweizerischen Datenschutzgesetzgebung verarbeitet.",
      },
      {
        heading: "15. Websites Dritter",
        body: "Diese Website kann zu Ihrer Bequemlichkeit Links zu externen Websites enthalten.\n\nClefs de Lys SA ist nicht verantwortlich für die Verfügbarkeit, den Inhalt, die Sicherheit oder die Datenschutzpraktiken von Websites Dritter.",
      },
      {
        heading: "16. Verfügbarkeit der Dienste",
        body: "Wir bemühen uns, einen kontinuierlichen Zugang zu unserer Website und unseren Online-Diensten aufrechtzuerhalten.\n\nWir garantieren jedoch keine ununterbrochene Verfügbarkeit und behalten uns das Recht vor, Dienste für Wartungsarbeiten, Sicherheitsupdates, technische Verbesserungen oder unvorhergesehene Umstände auszusetzen oder zu ändern.",
      },
      {
        heading: "17. Höhere Gewalt",
        body: "Clefs de Lys SA haftet nicht für Verzögerungen oder die Nichterfüllung ihrer Verpflichtungen, die auf Ereignisse außerhalb ihrer angemessenen Kontrolle zurückzuführen sind, einschließlich Naturkatastrophen, Streiks, Lieferantenstörungen, Cyber-Vorfälle, behördliche Maßnahmen oder andere Ereignisse höherer Gewalt.",
      },
      {
        heading: "18. Änderungen dieser AGB",
        body: "Wir können diese Allgemeinen Geschäftsbedingungen von Zeit zu Zeit aktualisieren.\n\nDie jeweils aktuelle Version wird stets mit dem aktualisierten Datum des Inkrafttretens auf dieser Website veröffentlicht.\n\nDie fortgesetzte Nutzung der Website nach der Veröffentlichung gilt als Annahme der geänderten AGB.",
      },
      {
        heading: "19. Anwendbares Recht",
        body: "Diese Allgemeinen Geschäftsbedingungen unterliegen dem schweizerischen Recht.\n\nStreitigkeiten aus diesen AGB oder der Nutzung unserer Dienstleistungen unterliegen der Zuständigkeit der zuständigen Gerichte des Kantons Freiburg, sofern nicht zwingendes Recht etwas anderes vorsieht.",
      },
      {
        heading: "20. Kontakt",
        body: "Wenn Sie Fragen zu diesen Allgemeinen Geschäftsbedingungen oder zu unseren Dienstleistungen haben, kontaktieren Sie Clefs de Lys SA bitte über die auf dieser Website verfügbaren Kontaktdaten.",
      },
    ],
  },
};